/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData } from './FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData';
import {
    instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData,
    FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSON,
} from './FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData';

/**
 * @type FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData
 * 
 * @export
 */
export type FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData = FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData;

export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData {
    return FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData(json)) {
        return FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSON(json: any): any {
    return FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData(value)) {
        return FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSON(value as FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData);
    }

    return {};
}

